import ErrorBoundaryWrapper from './error-boundary';

export default ErrorBoundaryWrapper;
